<template>
  <div id="app">
<router-view/> 
  </div>
</template>

<script>
export default {
 created(){
  this.getHAHA()
 },methods:{
  getHAHA(){
    //  const device = navigator.userAgent
    // if (device.indexOf('iPad') > -1) {
    //   //  ipad 
    //    alert('ipad')
    //   } else if (device.indexOf('Android') > -1 || device.indexOf('ios') > -1) {
    //   // 手机
    //   alert('手机')
    //   } else {
    //   // 电脑
    //   alert('电脑')
    //   }
    // if(this.$isMobile()){
    //   alert("移动")
    // }else{
    //   alert("电脑")
    // }
  }
 }

   }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/App.vue